// @ts-nocheck
import { textErrors } from '@/validation'

const ValidateFunctions = class {
  private emailRegex =
    // eslint-disable-next-line no-useless-escape
    /^[a-z0-9!#$%&*+\/=?^_`|~-]+(?:\.[a-z0-9!#$%&*+\/=?^_`|~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-zA-Z]{2,4}$/i

  private emailRegexExtendedDomain =
    // eslint-disable-next-line no-useless-escape
    /^[a-z0-9!#$%&*+\/=?^_`|~-]+(?:\.[a-z0-9!#$%&*+\/=?^_`|~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-zA-Z]{2,}$/i

  email(val: string) {
    return val && !this.emailRegex.test(val) && textErrors.email
  }

  emailExtendedDomain(val: string) {
    return val && !this.emailRegexExtendedDomain.test(val) && textErrors.email
  }

  emailValidator() {
    return {
      $validator: (value: string) => !value || this.emailRegex.test(value),
    }
  }

  tel(val: string) {
    return (
      val &&
      // val.length < 12 &&
      // eslint-disable-next-line no-useless-escape
      !/\+7\s\((\d{3})\)\s\d{3}-\d{4}/.test(val) &&
      textErrors.tel
    )
  }

  bsoSeries(val: string) {
    return val && !/^[0-9a-zA-Zа-яА-Я\s-]+$/.test(val) && textErrors.bsoSeries
  }

  bsoNumber(val: string) {
    return val && !/^[0-9]+$/.test(val) && textErrors.bsoNumber
  }

  officeWork(val: Record<string, string | object | number>) {
    return (
      !val?.value?.title?.toLowerCase().includes('агентский центр') &&
      !val?.value?.title?.toLowerCase().includes('универсальный офис') &&
      textErrors.officeWork
    )
  }

  telEpam(val: string) {
    return (
      val && !/^\+7\s\((\d{3})\)\s\d{3}(-\d{2}){2}$/.test(val) && textErrors.tel
    )
  }

  site(val: string) {
    return (
      val &&
      val &&
      // eslint-disable-next-line no-useless-escape
      !/(^https?:\/\/)?[a-z0-9~_\-\.]+\.[a-z]{2,9}(\/|:|\?[!-~]*)?$/i.test(
        val
      ) &&
      textErrors.site
    )
  }

  file(val: string) {
    return val && val.size > 1024 * 15 * 1024 && textErrors.file
  }

  files(val: File[]) {
    let sizeOfFiles = 0

    if (val?.length) {
      sizeOfFiles = val.reduce((acc, current) => current.size + acc, 0)
    }

    return val?.length && sizeOfFiles > 1024 * 20 * 1024 && textErrors.files
  }

  imageFile(val: File | null) {
    if (!val) return false
    const ext = /(?:\.([^.]+))?$/.exec(val.name)?.[1]?.toLowerCase()
    return !['jpeg', 'png', 'jpg'].includes(ext || '') && textErrors.imageFile
  }

  maxFileSize(val: File | null) {
    return !!val && val.size > 1024 * 15 * 1024 && textErrors.maxFileSize(15)
  }

  vuelidateFilesSize(size: number) {
    return {
      $validator: (val: File[]) => {
        let sizeOfFiles = 0

        if (val?.length) {
          sizeOfFiles = val.reduce((acc, current) => current.size + acc, 0)
        }
        return sizeOfFiles < 1024 * size * 1024
      },
      $params: {
        size,
      },
    }
  }

  validateFilesFormat(formats: string[]) {
    return {
      $validator: (files) => {
        for (let i = 0; i < files.length; i++) {
          if (
            !formats.includes(
              /(?:\.([^.]+))?$/.exec(files[i].name)?.[1]?.toLowerCase()
            )
          ) {
            return false
          }
        }
        return true
      },
      $params: {
        formats,
      },
    }
  }

  validateFilesCount(count: number) {
    return {
      $validator: (val: File[]) => {
        return val?.length <= count
      },
      $params: {
        count,
      },
    }
  }

  required(
    val: string | boolean | object | null | undefined | number,
    errorText = ''
  ) {
    if (typeof val === 'string') {
      val = val.trim()
    }

    if (!val) {
      return errorText || textErrors.required
    }
  }

  accept(val: boolean) {
    if (!val) {
      return textErrors.accept
    }
  }

  acceptEng(val: boolean) {
    if (!val) {
      return textErrors.acceptEng
    }
  }

  excludesRegions(val: object) {
    return val?.excludeError && textErrors.excludesRegions
  }

  excludesOffices(val: object) {
    return val?.value?.excludeError && textErrors.excludesOffices
  }

  region(val: object) {
    const error = val?.region
    return !error && textErrors.region
  }

  regionExcludeNewRegions(val: object) {
    const excludeNewRegions = [
      'Донецкая Народная респ',
      'Херсонская обл',
      'Луганская Народная респ',
      'Запорожская обл',
    ]

    const isNewRegion = excludeNewRegions.includes(val?.regionWithType)

    const error = isNewRegion || val?.region
    return !error && textErrors.region
  }

  city(val: object) {
    const error = val?.city
    return !error && textErrors.city
  }

  street(val: object) {
    const error = val?.street
    return !error && textErrors.street
  }

  house(val: object) {
    const error = val?.house || val?.block
    return !error && textErrors.house
  }

  district(val: object) {
    const error = val?.district
    return !error && textErrors.district
  }

  cyrillic(val: string) {
    return !/^[а-яА-ЯёЁ]*$/.test(val) && textErrors.cyrillic
  }

  vuelidateCyrillicWithoutWhitespace() {
    return /^[а-яА-ЯёЁ\-]*$/
  }

  vuelidateWhitespace() {
    return /^\S+$/
  }

  vuelidateCyrillic() {
    return /^[а-яА-ЯёЁ\- ]*$/
  }

  vuelidateLatin() {
    return /^[a-zA-Z\- ]*$/
  }

  validateCyrillic(val) {
    if (val && !/^[а-яА-ЯёЁ-]*$/.test(val)) {
      return textErrors.validateCyrillic
    }
  }

  validateCyrillicAndSpace(val) {
    if (val && !/^[а-яА-ЯёЁ\- ]*$/.test(val)) {
      return textErrors.validateCyrillic
    }
  }

  validateLatin(val) {
    if (val && !/^[a-zA-Z-]*$/.test(val)) {
      return textErrors.validateLatin
    }
  }

  validateLatinAndSpace(val) {
    if (val && !/^[a-zA-Z\- ]*$/.test(val)) {
      return textErrors.validateLatin
    }
  }

  dateBigger(val: string, date: string) {
    if (val && date) {
      const firstDateArr = val.split('.').reverse()
      const secondDateArr = date.split('.').reverse()
      return (
        new Date(...firstDateArr) > new Date(...secondDateArr) &&
        textErrors.dateBiggerText
      )
    }
    return false
  }

  minLength(val: string, min: number) {
    return val && val.length < min && textErrors.minLength + ` ${min} символов`
  }

  maxLength(val: string, max: number) {
    return val && val.length > max && textErrors.maxLength + ` ${max} символов`
  }

  fullName(val: string) {
    if (!val || val.length < 3) {
      return textErrors.userCountSymbols
    }
    if (/[0-9!$%^&*_¡?÷=@#—ˆ(){}|~<>%,.;:¿+`[\]"'/]/.test(val)) {
      return textErrors.userName
    }
    if (val.split(' ').filter((v) => v).length < 3) {
      return textErrors.fullName
    }
  }

  simpleName(val: string) {
    if (!val || val.length < 3) {
      return textErrors.userCountSymbols
    }
    if (/[0-9!$%^&*_¡?÷=@#—ˆ(){}|~<>%,.;:¿+`[\]"'/]/.test(val)) {
      return textErrors.userName
    }
    if (val.split(' ').filter((v) => v).length < 2) {
      return textErrors.simpleName
    }
    if (/[a-zA-Z]/.test(val)) {
      return textErrors.fullEpamName
    }
  }

  fullEpamName(val: string) {
    if (val?.length) {
      const name = val.split(' ')
      if (
        !/^[А-ЯЁ]{1}[-'а-яё]*([-'][А-ЯЁ])?[-'а-яё]*[а-яё]$/.test(name[0]) ||
        /[-'\s]{2,}/.test(name[0])
      ) {
        return textErrors.fullEpamName
      }
      if (
        !/^(([А-ЯЁ]{1}[-'а-яё]*([-'][А-ЯЁ])?[-'а-яё]*[а-яё])|([А-ЯЁ]))$/.test(
          name[1]
        ) ||
        /[-'\s]{2,}/.test(name[1])
      ) {
        return textErrors.fullEpamName
      }
      if (
        name.length > 2 &&
        (!/^(([А-ЯЁ]{1}[-'а-яё]*([-'][А-ЯЁ])?[-'а-яё]*[а-яё])|([А-ЯЁ]))$/.test(
          name[2]
        ) ||
          /[-'\s]{2,}/.test(name[2]))
      ) {
        return textErrors.fullEpamName
      }
    }
    return false
  }

  userName(val: string) {
    if (!val || val.length < 3) {
      return textErrors.userCountSymbols
    }
    if (/[0-9!$%^&*_¡?÷=@#—ˆ(){}|~<>%,.;:¿+`[\]"'/]/.test(val)) {
      return textErrors.userName
    }
  }

  userNameSpecialSymbols(val: string) {
    if (/[0-9!$%^&*_¡?÷=@#—ˆ(){}|~<>%,.;:¿+`[\]"'/]/.test(val)) {
      return textErrors.userName
    }
  }

  userNameInsurance(val: string) {
    if (/[0-9!$%^&*_¡?÷=@#—ˆ(){}|~<>%,.;:¿+`[\]"'/]/.test(val)) {
      return textErrors.userName
    }
  }

  dateDDmmYYYY(val: string) {
    return (
      val &&
      !/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.\d{4}$/.test(val) &&
      textErrors.dateDDmmYYYY
    )
  }

  vuelidateDateDDmmYYYY() {
    return /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.\d{4}$/
  }

  vuelidateDateYYYYMMDD() {
    return /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
  }

  dateAndTime(val: string) {
    if (/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.\d{4}$/.test(val)) {
      const dateItem = val.match(/^(\d{2})\.(\d{2})\.(\d{4})$/)
      const checkedDate = new Date(+dateItem[3], dateItem[2] - 1, +dateItem[1])
      if (checkedDate - new Date() > 0) return textErrors.dateAndTime.max
      if (dateItem[3] * 1 < 1900) return textErrors.dateAndTime.min
    } else {
      return textErrors.dateAndTime.syntax
    }
  }

  zipCode(val: string) {
    return !/^\d{6}/.test(val) && textErrors.zipCode
  }

  carChassisNumber(val: string) {
    return !/^(\d{4}|\d{6})/.test(val) && textErrors.carChassisNumber
  }

  carBodyNumber(val: string) {
    return !/^(\w{9}|\w{12})/.test(val) && textErrors.carBodyNumber
  }

  carVinCode(val: string) {
    return !/^(\w{17})/.test(val) && textErrors.vinCode
  }

  osagoSeries(val: string) {
    return (
      !/(^А{3}$)|(^А{2}В$)|(^В{3}$)|(^С{3}$)|(^Е{3}$)|(^Х{3}$)|(^К{3}$)|(^М{3}$)|(^Н{3}$)|(^Р{3}$)|(^Т{3}$)/.test(
        val
      ) && textErrors.osagoSeries
    )
  }

  osagoNumber(val: string) {
    return !/^\d{10}$/.test(val) && textErrors.osagoNumber
  }

  driverLicense(val: string) {
    return !/^\d{10}$/.test(val) && textErrors.driverLicense
  }

  passportSeries(val: string) {
    return !/^\d{2}\s\d{2}$/.test(val) && textErrors.passportSeries
  }

  passportNumber(val: string) {
    return !/^\d{6}$/.test(val) && textErrors.passportNumber
  }

  passportSeriesNumber(val: string) {
    return !/\d{4} \d{6}/.test(val) && textErrors.passportNumber
  }

  vuelidatePassportSeriesNumber() {
    return /\d{4} \d{6}/
  }

  vuelidateBirthCertificate(val: string) {
    return val && val.length <= 25
  }

  vuelidatePreviousRequest() {
    return /[a-zA-Zа-яА-Я]-\d+$/gi
  }

  passportSeriesNumberNotRequired(val: string) {
    if (!val) return val
    return !/\d{4} \d{6}/.test(val) && textErrors.passportNumber
  }

  drivingLicenceSer(val: string) {
    return (
      !/^\d{2}\s[0-9A-Za-zА-Яа-я]{2}$/.test(val) && textErrors.drivingLicenceSer
    )
  }

  drivingLicenceNumber(val: string) {
    return !/^\d{6}$/.test(val) && textErrors.drivingLicenceNumber
  }

  enginePower(val: string) {
    return !/^\d{1,5}([.,]\d)?$/.test(val) && textErrors.enginePower
  }

  registrationPlate(val: string) {
    return (
      !/^[АВЕКМНОРСТУХ\d]\d{3}[АВЕКМНОРСТУХ\d]{2}\s\d{2,3}$/.test(val) &&
      textErrors.registrationPlate
    )
  }

  vinCode(val: string) {
    return (
      (!/^(?=.*\d)(?=.*[A-HJ-NPR-Z])[A-HJ-NPR-Z0-9]{17}$/.test(val) ||
        /(.)\1{8,}/.test(val)) &&
      textErrors.vinCode
    )
  }

  bodyNumber(val: string) {
    return (
      (!/^[A-Z\d-]{1,24}$/.test(val) || /(.)\1{8,}/.test(val)) &&
      textErrors.bodyNumber
    )
  }

  number(val: string) {
    return !/^\d+(\.\d+)?$/.test(val) && textErrors.number
  }

  numberCountRequests(val: string) {
    return !/^([1-9]([0-9]{0,2}))$/.test(val) && textErrors.numberCountRequests
  }

  async osagoPolicies(_: any, __: any, additionalData: any = null) {
    let status = false
    if (additionalData) {
      const { component, showError } = additionalData
      if (component && component[0]?.checkErrors) {
        // Если вернёт true то ошибки есть
        if (await component[0].checkErrors(showError)) status = true
      }
    }
    return status
  }

  innLength(val: string) {
    return val && val.length !== 12 && textErrors.innLength
  }

  policyNumber(val) {
    return val?.length > 12
  }

  phoneHasNoSameNumbers() {
    return {
      $validator: (phone: string) => {
        const numbers = phone.match(/\d+/g)?.reduce((a, c) => a + c)
        let set = null
        if (numbers) {
          set = new Set(numbers)
        }
        return set?.size > 2
      },
    }
  }

  phoneIsCorrect() {
    return {
      $validator: (phone: string) => {
        return phone !== '+7 (123) 123-12-31'
      },
    }
  }
}

export default new ValidateFunctions()
